import { render, staticRenderFns } from "./SchemaEditor.vue?vue&type=template&id=0811f6e8&scoped=true&"
import script from "./SchemaEditor.vue?vue&type=script&lang=js&"
export * from "./SchemaEditor.vue?vue&type=script&lang=js&"
import style0 from "./SchemaEditor.vue?vue&type=style&index=0&id=0811f6e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811f6e8",
  null
  
)

export default component.exports